import { useSnapshot } from 'valtio';

import * as navigationStore from '@cartwhl/common/stores/navigationStore';
import * as updatedProductStore from '@cartwhl/common/stores/updatedProductStore';

import useMediaQuery from '../hooks/useMediaQuery';

/** Match studio timeline mobile layout (`md` breakpoint). */
export const WIZARD_MOBILE_MEDIA_QUERY = '(max-width: 768px)';

export function useWizardsAllowed(): boolean {
  const isMobile = useMediaQuery(WIZARD_MOBILE_MEDIA_QUERY);
  const { modal } = useSnapshot(navigationStore.state);
  const purchaseCreditsModal = useSnapshot(
    updatedProductStore.purchaseCreditsModalState,
  );
  const activateEarlyTrialModal = useSnapshot(
    updatedProductStore.activateEarlyTrialModalState,
  );

  if (isMobile) {
    return false;
  }

  if (modal.type !== '') {
    return false;
  }

  if (purchaseCreditsModal.isOpen || activateEarlyTrialModal.isOpen) {
    return false;
  }

  return true;
}
